import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ResetPasswordCredentials } from '../types/auth.types';

export const usePasswordReset = () => {
  const { forgotPassword, resetPassword } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleForgotPassword = async (username: string) => {
    setIsLoading(true);
    setError(null);
    try {
      await forgotPassword(username);
    } catch (err: any) {
      setError(err.response?.data?.message || 'An error occurred while requesting password reset');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async (credentials: ResetPasswordCredentials) => {
    setIsLoading(true);
    setError(null);
    try {
      await resetPassword(credentials);
    } catch (err: any) {
      setError(err.response?.data?.message || 'An error occurred while resetting password');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    handleForgotPassword,
    handleResetPassword,
  };
};
